import React from 'react';

import { Block } from '@randajan/jet-react/dom/block';

import "./AppLink.scss";
import { page } from '@randajan/jet-react/base/page';
import { getActualVersion, linkAbout, linkFetch } from '../../config/link';
import { usePromise } from '@randajan/jet-react';

import toJSX from "@randajan/js-object-view/jsx";
import { usePop } from '@randajan/jet-react/dom/modal';
import { Button } from '@randajan/jet-react/dom/form';

export const DownloadLink = ()=>{
    return (
        <div className="DownloadLink">
            Aplikace nenalezena.
            <a href="/link/repo/stable/linkSetup.exe">Stáhnout aplikaci</a>;
        </div>
    )
}

export const ShowResult = (props)=>{
    const { action, args } = props;
    const { result, status, error } = usePromise(null, _=>linkFetch(action, args), []);

    console.log(result);

    return (
        <div className="ShowResult" data-status={status}>
            { result ? toJSX(result) : null }
        </div>
    )
}

export const LinkControl = (props)=>{
    const { version } = props;


    const pop = usePop();

    return (
        <div className="LinkControl">
            <div>Instalovaná verze: {version}</div>
            { <Button onSubmit={_=>{pop.up(<ShowResult action="system/info"/>)}}>Základní informace</Button> }
            { <Button onSubmit={_=>{pop.up(<ShowResult action="system/state"/>)}}>Diagnostická data</Button> }
            { <Button onSubmit={_=>{pop.up(<ShowResult action="update" args={{force:true}}/>)}}>Aktualizuj</Button> }
        </div>
    )
}

export const AppLink = (props)=>{
    const {} = props;

    const { result:actualVersion } = usePromise(null, _=>getActualVersion(), []);
    const { result:about, status } = usePromise(null, _=>linkAbout(), []);

    const [ search ] = page.use("search");
    const ss = search.get("status");

    
    return (
        <Block className="AppLink wall block" caption="LINK" level={0}>
            <div>Aplikace právě prochází beta testováním, veškeré podniknuté kroky jsou na Vaše vlastní riziko</div>
            {!actualVersion ? null : <div>Aktuální verze: {actualVersion}</div>}
            {ss === "installed" ? <div>Aplikace nainstalována</div> : ss === "uninstalled" ? <div>Mrzí nás že odcházíte</div> : null}
            <div className="connection" data-status={status}>
                { (status !== "error" && status !== "done") ? "" : !about ? <DownloadLink/> : <LinkControl {...about}/> }
            </div>
        </Block>
    )
}

